import * as React from 'react';
import { FormState } from '../types';

interface Props {
  form: FormState;
  set: (patch: Partial<FormState>) => void;
}

const FIELDS: Array<{ key: keyof FormState['restrictions']; label: string; title: string }> = [
  { key: 'length',   label: 'length (m)',   title: 'Vehicle length in meters. Example: 16.5' },
  { key: 'width',    label: 'width (m)',    title: 'Vehicle width in meters. Example: 2.5' },
  { key: 'height',   label: 'height (m)',   title: 'Vehicle height in meters. Example: 4.0' },
  { key: 'weight',   label: 'weight (t)',   title: 'Total weight in tons. Example: 40.0' },
  { key: 'axleload', label: 'axleload (t)', title: 'Axle load in tons. Example: 11.5' },
];

export default function TruckRestrictions({ form, set }: Props) {
  const upd = (k: keyof FormState['restrictions'], v: string | boolean) => {
    set({ restrictions: { ...form.restrictions, [k]: v } as FormState['restrictions'] });
  };
  return (
    <section>
      <h2>Truck Restrictions (HGV)</h2>
      <div className="grid2">
        {FIELDS.map(f => (
          <label key={f.key} title={f.title}>
            {f.label}
            <input
              type="number" step={0.1}
              value={(form.restrictions[f.key] as string) ?? ''}
              onChange={(e) => upd(f.key, e.target.value)}
            />
          </label>
        ))}
        <label className="checkbox" title="Carrying hazardous materials.">
          <input
            type="checkbox"
            checked={form.restrictions.hazmat}
            onChange={(e) => upd('hazmat', e.target.checked)}
          /> hazmat
        </label>
      </div>
    </section>
  );
}

